module.exports = __webpack_public_path__ + "static/media/dpl-logo-header.986922ae.png";